import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import qs from 'qs'
import _ from 'lodash'

const vm = new Vue()
const sanApiBaseUrl = _.trim(process.env.VUE_APP_SAN_API_BASEURL, '/')

const oAuthRequest = axios.create({
    baseURL: `${sanApiBaseUrl}/oauth2`,
    timeout: 30000
})

const appRequest = axios.create({
    baseURL: `${sanApiBaseUrl}`,
    timeout: 30000
})

appRequest.interceptors.request.use(function (config) {
    let accessToken = store.state.authorization.app
    config.headers['Authorization'] = `${accessToken.token_type} ${accessToken.access_token}`
    config.headers['Accept'] = 'application/json'
    return config
})

const userRequest = axios.create({
    baseURL: `${sanApiBaseUrl}`,
    timeout: 30000
})

userRequest.interceptors.request.use(function (config) {
    let accessToken = store.state.authorization.user
    config.headers['Authorization'] = `${accessToken.token_type} ${accessToken.access_token}`
    config.headers['Accept'] = 'application/json'
    return config
})

export default {
    userRequest(options) {
        return new Promise((resolve, reject) => {
            if (options) {
                if (options.url && !options.url.includes('language')) {
                    if (options.url.includes('?')) {
                        options.url = `${options.url}&language=${vm.$ml.current}`
                    } else {
                        options.url = `${options.url}?language=${vm.$ml.current}`
                    }
                }
            }

            userRequest(options).then(response => {
                const result = response.data ? response.data : {}
                result.response = response
                return resolve(result)
            }).catch(e => {
                reject(e)
            })
        })
    },

    appRequest(options) {
        return new Promise((resolve, reject) => {
            if (options) {
                if (options.url) {
                    if (options.url && !options.url.includes('language')) {
                        if (options.url.includes('?')) {
                            options.url = `${options.url}&language=${vm.$ml.current}`
                        } else {
                            options.url = `${options.url}?language=${vm.$ml.current}`
                        }
                    }
                }
            }

            appRequest(options).then(response => {
                let result = response.data
                result.response = response
                return resolve(result)
            }).catch(e => {
                return reject(e)
            })
        })
    },

    authenticateUser(username, password) {
        let api = this
        return new Promise((resolve, reject) => {
            api.requestUserAccessToken({
                username,
                password
            }).then(() => {
                api.userRequest({
                    url: `/user/me/info?language=${vm.$ml.current}`,
                    method: 'get'
                })
                .then(({ user }) => resolve(user))
                .catch(e => reject(e))
            }).catch(e => reject(e))
        })
    },

    requestUserAccessToken(data) {
        return new Promise((resolve, reject) => {
            oAuthRequest.request({
                url: `token?language=${vm.$ml.current}`,
                method: 'post',
                data: qs.stringify({
                    ...data,
                    grant_type: 'frequenter',
                    client_id: 'user-app-login@navedoconhecimento',
                    client_secret: '35416a7ex31021e77c5c52d5d084e973dac2a0b1',
                    scope: 'me_info,me_update,me_survey_to_answer,booking_start'
                })
            }).then(response => {
                store.commit('setAuthorizationUser', response.data)
                resolve(response.data)
            }).catch(reject)
        })
    },

    requestAppAccessToken() {
        const credential = store.getters.getCredential
        return new Promise((resolve, reject) => {
            oAuthRequest.request({
                url: `token?language=${vm.$ml.current}`,
                method: 'post',
                data: qs.stringify({
                    grant_type: 'client_credentials',
                    client_id: credential.client_id,
                    client_secret: credential.client_secret,
                    scope: 'equipment_search,survey_interview_store,background_search'
                })
            }).then(response => {
                resolve(response.data)
            }).catch(e => {
                if (e.response && e.response.data && e.response.data.exception && e.response.data.exception.message) {
                    return reject(e.response.data.exception)
                } else {
                    return reject(e.message)
                }
            })
        })
    },

    renewAppAccessToken() {
        return new Promise((resolve, reject) => {
            if (store.state.authorization.app) {
                resolve()
            } else {
                reject()
            }
        })
    }

}